<template lang="pug">
  .lei-input(:class="rootClass")
    lei-popover.label-tip-box(:text="tip", :placement="tipPlacement" :width="tipWidth")
      label.label(:for="cbId") {{label}}
    input.input(
      :disabled="disabled",
      :id="cbId", :value="value", :type="type",
      @input="inputValue($event.target.value)",
      @change="changeValue($event.target.value)",
      @keyup.enter="keyEnter"
      v-bind="inputAttrs")
</template>

<script>
import cdId from '../../../mixins/cd-id'
import LeiPopover from '../LeiPopover'

export default {
  components: { LeiPopover, },
  mixins: [ cdId, ],
  props: {
    rootClass: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [ String, Number, ],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    inputAttrs: {
      type: Object,
      default: () => ({}),
    },
    tip: {
      type: [ String, Object, ],
      default: () => ({
        small: '',
        full: '',
      }),
    },
    tipPlacement: {
      type: [ String, ],
      default: 'right',
    },
    tipWidth: {
      type: Number,
      default: 220,
    },
  },
  methods: {
    inputValue (value) {
      this.$emit('input', value)
    },
    changeValue (value) {
      this.$emit('change', value)
    },
    keyEnter (e) {
      this.$emit('enter', e.target.value)
    },
  },
}
</script>

<style lang="stylus">
  @import "../../../assets/styles/variables.styl"
  .lei-input
    .input
      &:disabled
        cursor not-allowed

  @media screen and (min-width $tablet)
    .lei-input
      .input
        &:disabled
          color $disabled-color !important
          background-color $disabled-bg !important
          border-color $disabled-border !important
</style>



// WEBPACK FOOTER //
// src/components/lei-components/inputs/LeiInput.vue